import "./App.css";
import Layout from "./components/Layout";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { ScrollProvider } from "./components/Scrollcontext";
import Feature from "./components/Feature";
import Resources from "./components/Resources";
import Lmia from "./components/Lmia";
import Visitor from "./components/Visitor";
import Legal from "./components/Legal";
import Enduser from "./components/Enduser";
import Privacy from "./components/Privacy";

function App() {
  return (
    <ScrollProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="home" element={<Home />} />
          <Route exact path="about" element={<About />} />
          <Route path="home/about" element={<About />} />
          <Route exact path="feature" element={<Feature/>} />
          <Route path="home/feature" element={<Feature/>} />
          <Route exact path="resources" element={<Resources/>} />
          <Route path="resources/lmia" element={<Lmia/>} />
          <Route path="resources/visit" element={<Visitor/>}/>
          <Route exact path="contact" element={<Contact />} />
          <Route exact path="legal" element={<Legal/>}/>
          <Route path="legal/end-user-license-agreement" element={<Enduser/>} />
          <Route path="legal/Privacy-policy" element={<Privacy/>} />
          <Route path="/" element={<Navigate replace to="/home" />} />
          </Route>
      </Routes>
    </BrowserRouter>
    </ScrollProvider>
  );
}

export default App;
